module.exports = __webpack_public_path__ + "static/media/datasource-icon-light.7ca2b103.svg";